<template>
  <div>
    <div class="wraper w-100">
      <ul class="container">
        <li
          class="link"
          :class="{'active': step === 1 || step === 2 || step === 3 }"
        >
          <a href="">Paso 1  - Ver Factura</a>
        </li>
        <li
          class="link"
          :class="{'active': step === 2 || step === 3 }"
        >
          <a href="">Paso 2 - Pagar Factura</a>
        </li>
        <li
          :class="{'active': step === 3 }"
          class="link "
        >
          <a href="">Paso 3 - Confirmaci&oacute;n</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    step: {
      required: true,
      type: Number
    }
  }
};
</script>

<style scoped lang="scss">
    .wraper {
        padding-top: 50px;
        text-align: center;
        font-family: sans-serif;
        width: 100%;
        margin: 10px auto;
    }
    .container {
        display: flex;
        list-style: none;
        padding: 0;
        justify-content: space-between;
        align-items: stretch;
        align-content: stretch;
    }
    .link {
        border-top: 3px solid lightgrey;
        position: relative;
        padding-top: 10px;
        width: 100%;
    }
    .active{
        border-top: 3px solid #2d2926;
    }
    .link a {
        font-weight: bold;
        text-decoration: none;
        color: #2d2926;
        text-transform: uppercase;
        font-size: 15px;
    }
    .link::after {
        content: "";
        width: 10px;
        height: 10px;
        background: get-color('clear');
        position: absolute;
        border-radius: 10px;
        top: -7px;
        left: 50%;
        transform: translatex(-50%);
        border: 2px solid #A7A8AA;
    }
    .link.active::after {
        background: #2d2926;
        border: 2px solid #2d2926;
    }

</style>
